<template>
  <component
    :is="tag"
    :href="href ? href : undefined"
    :to="modLink || to || undefined"
    :target="target"
    :data-id="id"
    class="swiper-slide"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { NuxtLink } from '#components';
import ModLink from '@/mixins/ModLink';

export default defineComponent({
  mixins: [ModLink],
  props: {
    title: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: undefined,
    },
    to: {
      type: [Object, String],
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    tag() {
      if (!this.to && !this.href) {
        return 'div';
      }

      return NuxtLink;
    },
  },
});
</script>

<style lang="scss" scoped>
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  transform: translate3d(0, 0, 0);

  &:focus-visible {
    @include focus-outline-layered;
  }
}

.swiper-slide.swiper-slide {
  width: auto;
  text-decoration: none;
}
</style>
